import {ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {UtilService} from '../../services/util.service';

@Component({
    selector: 'app-vin',
    templateUrl: './vin.component.html',
    styleUrls: ['./vin.component.scss']
})
export class VinComponent implements OnInit, OnChanges {

    @Input() vin: string;
    @Output() vinChange = new EventEmitter();
    @Output() vinEdited = new EventEmitter();

    private replacements = {
        i: '1',
        I: '1',
        o: '0',
        O: '0',
        q: '0',
        Q: '0'
    };

    private maxLength = [3, 8, 6];
    public parts: string[] = [];

    constructor(private cd: ChangeDetectorRef) {
    }

    ngOnInit() {
        if (this.vin !== undefined) {
            this.parseVin();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.vin !== undefined) {
            this.parseVin();
            // this.onChange();
        }
    }

    private parseVin() {
        this.parts[0] = '';
        this.parts[1] = '';
        this.parts[2] = '';
        if (this.vin && this.vin.length > 17) {
            this.vin = this.vin.substring(0, 17);
        }
        if (this.vin !== null && this.vin !== '') {
            this.vin = UtilService.replaceAll(this.vin, this.replacements);
            if (this.vin.length >= 3) {
                this.parts[0] = this.vin.substr(0, 3);
                this.parts[1] = this.vin.substr(3);
            }
            if (this.vin.length >= 11) {
                this.parts[1] = this.vin.substr(3, 8);
            }
            if (this.vin.length > 11) {
                this.parts[2] = this.vin.substr(11);
            }
        }
        this.cd.markForCheck();
    }

    @HostListener('copy', ['$event']) onCopy(event: any) {
        const clipboard = event.clipboardData || window['clipboardData'];
        clipboard.setData('text', this.parts.join(''));
        event.preventDefault();
    }

    @HostListener('paste', ['$event']) onPaste(event: any) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (typeof event.clipboardData === 'undefined') {
            this.vin = window['clipboardData'].getData('Text');
        } else {
            this.vin = event.clipboardData.getData('text/plain');
        }
        this.parseVin();
        this.onChange();
        this.vinEdited.emit();
    }

    @HostListener('select', ['$event']) onSelect(event: Event) {
    }

    clearFields() {
        this.vin = null;
        this.parseVin();
        this.onChange();
    }

    /*updateVin($event: any, index: number, nextEl?: any) {
        if (index < 2) {
            if (this.parts[index].length === this.maxLength[index]) {
                setTimeout(() => nextEl.input.nativeElement.focus(), 0);
            }
        }
        this.vin = this.parts.join('');
        this.onChange();
    }*/

    private onChange() {
        if (this.vin === null || this.vin === undefined || this.vin === '' || this.vin.length === 17) {
            this.vinChange.emit(this.vin);
        }
    }

    onKeyUp($event: KeyboardEvent, control: any, number: number, control2?: any) {
        const charCode = $event.which || $event.keyCode;
        const charStr = String.fromCharCode(charCode);
        const caretPosition = control.input.nativeElement.selectionStart;
        const selectionEnd = control.input.nativeElement.selectionEnd;
        if (/[a-z0-9]/i.test(charStr)) {

            if (this.parts[number].length + 1 > this.maxLength[number]) {
                event.preventDefault();
                event.stopImmediatePropagation();
                if (caretPosition === this.parts[number].length) {
                    this.parts[number] = this.parts[number] + charStr;
                } else {
                    this.parts[number] = this.parts[number].substr(0, caretPosition) + charStr +
                        this.parts[number].substr(selectionEnd);
                }
                if (control2) {
                    setTimeout(() => control2.input.nativeElement.focus(), 0);
                }
                let start = number;
                while (start < 2) {
                    this.parts[start + 1] = this.parts[start].substring(this.maxLength[start]) + this.parts[start + 1];
                    this.parts[start] = this.parts[start].substring(0, this.maxLength[start]);
                    start++;
                }
                this.parts[2] = this.parts[2].substring(0, this.maxLength[2]);
            } else if (this.parts[number].length + 1 === this.maxLength[number] && control2 !== undefined
                && this.parts[number + 1].length === 0) {
                setTimeout(() => control2.input.nativeElement.focus(), 0);
            }
        } else {
            setTimeout(() => {
                if (this.parts[number].length < this.maxLength[number]
                    && this.parts[number + 1] && this.parts[number + 1].length > 0) {
                    const diff = this.maxLength[number] - this.parts[number].length;
                    this.parts[number] = this.parts[number] + this.parts[number + 1].substring(0, diff);
                    this.parts[number + 1] = this.parts[number + 1].substring(diff);
                    this.cd.markForCheck();
                }
                if (charCode === 8 || charCode === 46) {
                    setTimeout(() => {
                        control.input.nativeElement.selectionStart = charCode === 8 ? caretPosition - 1 : caretPosition;
                        control.input.nativeElement.selectionEnd = charCode === 8 ? caretPosition - 1 : caretPosition;

                    });
                }

            });

        }

        this.vin = this.parts.join('');
        this.cd.markForCheck();
        this.onChange();
        this.vinEdited.emit();
    }
}
